import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IArticulo } from '@models/IArticulo';
import { IOperador, IGestor } from '@models/IOperador';
import { IUltimoStock } from '@models/IUltimoStock';
import { environment } from 'environments/environment';
import { Observable, throwError } from 'rxjs';
import { UserService } from './user.service';
import { INotification } from '@models/INotification';
import { IArticuloInventario } from '@features/notificar-inventario/pages/notificar-inventario/notificar-inventario.component';
import { KeysEstaticas } from '@shared/constantes/KeysStaticas';

@Injectable({
  providedIn: 'root',
})
export class OperadorService {
  readonly SESSION_IDIOMA = KeysEstaticas.SESSION_IDIOMA;
  constructor(
    private http: HttpClient,
    private userService: UserService,
  ) { }

  //9.1. GET: Funcion que devuelve los datos de un operador
  getOperador(): Observable<IOperador> {
    const idOperador = this.userService.getUserInfo()?.idOperador;

    if (!idOperador) {
      return throwError(() => new Error('No se ha encontrado idOperador en userService'));
    }

    return this.http.get<IOperador>(
      environment.API_URL + 'cliente/operador',
      {
        params: {
          idOperador: String(idOperador),
        },
      },
    );
  }

  //9.3. PUT: Funcion que edita un operador (en datos operador)
  // TODO => contactoReclamaciones ESTO ES UNDEFINED MIRAR A VER Y PASAR BIEN EL DATO
  putEditOperador(contactoReclamaciones: string, emailFacturacion: string) {
    const idOperador = this.userService.getUserInfo()?.idOperador;

    if (!idOperador) {
      return throwError(() => new Error('No se ha encontrado idOperador en userService'));
    }

    const body = { contactoReclamaciones, emailFacturacion };

    return this.http.put<IOperador>(
      `${environment.API_URL}cliente/operador`,
      body,
      {
        params: { idOperador: String(idOperador) },
      }
    );
  }


  //9.4. GET: Funcion que devuelve los articulos autorizados para un operador
  getArticulosAll(): Observable<IArticulo[]> {
    const idOperador = this.userService.getUserInfo()?.idOperador;
    const idioma = sessionStorage.getItem(this.SESSION_IDIOMA) || this.userService.getIdioma();

    if (!idOperador) {
      return throwError(() => new Error('No se ha encontrado idOperador en userService'));
    }

    return this.http.get<IArticulo[]>(
      environment.API_URL + 'cliente/operador/articulos/all',
      {
        params: {
          idOperador: String(idOperador),
          idioma: idioma,
        },
      },
    );
  }

  //9.11. GET: Funcion que devuelve los articulos autorizados x centro para un operador
  getArticulosCentroAll(centro: number): Observable<IArticulo[]> {
    const idOperador = this.userService.getUserInfo()?.idOperador;
    const idioma = sessionStorage.getItem(this.SESSION_IDIOMA) || this.userService.getIdioma();

    if (!idOperador) {
      return throwError(() => new Error('No se ha encontrado idOperador en userService'));
    }

    return this.http.get<IArticulo[]>(
      environment.API_URL + 'cliente/operador/centro/articulos/all',
      {
        params: {
          idOperador: String(idOperador),
          idioma: idioma,
          centro: String(centro),
        },
      },
    );
  }

  //9.6. GET: Funcion que devuelve los datos del ultimo Stock
  getUltimoStockAll(): Observable<IUltimoStock> {
    const idOperador = this.userService.getUserInfo()?.idOperador;
    const idioma = sessionStorage.getItem(this.SESSION_IDIOMA) || this.userService.getIdioma();

    if (!idOperador) {
      return throwError(() => new Error('No se ha encontrado idOperador en userService'));
    }

    return this.http.get<IUltimoStock>(
      environment.API_URL + 'cliente/operador/stock/ultimo/all',
      {
        params: {
          idOperador: String(idOperador),
          idioma: idioma,
        },
      },
    );
  }

  //9.7. POST: Funcion que crea un inventario
  postInventarioAdd(inventario: { fecha: Date; observaciones: string; inventario: IArticuloInventario[] }) {
    const idOperador = this.userService.getUserInfo()?.idOperador;

    return this.http.post<unknown>(
      environment.API_URL + 'cliente/operador/inventario/all',
      inventario,
      {
        params: {
          idOperador: String(idOperador),
        },
      },
    );
  }

  //9.8. GET: Funcion que devuelve el listado de los inventarios
  // getInventario()
  // {

  // }

  //9.9. POST: Funcion que crea un pedido extra
  postPedidoExtraAdd(artiuculos: { fecha: string; centro: number; observaciones: string; pedido: IArticulo[] }) {
    const idOperador = this.userService.getUserInfo()?.idOperador;

    if (!idOperador) {
      return throwError(() => new Error('No se ha encontrado idOperador en userService'));
    }

    console.log(artiuculos);

    return this.http.post<unknown>(
      environment.API_URL + 'cliente/operador/pedidoextra',
      artiuculos,
      {
        params: {
          idOperador: String(idOperador),
        },
      },
    );
  }

  getNotificaciones(): Observable<INotification[]> {
    const idOperador = this.userService.getUserInfo()?.idOperador;
    const idioma = sessionStorage.getItem(this.SESSION_IDIOMA) || this.userService.getIdioma();

    if (!idOperador) {
      return throwError(() => new Error('No se ha encontrado el operador activo.'));
    }

    return this.http.get<INotification[]>(
      `${environment.API_URL}cliente/operador/notificaciones/all`,
      {
        withCredentials: true,
        params: {
          idioma: idioma!,
          idOperador: String(idOperador),

        },
      }
    );
  }


  getFechasPedidoExtra() {
    const idOperador = this.userService.getUserInfo()?.idOperador;

    if (!idOperador) {
      return throwError(() => new Error('No se ha encontrado idOperador en userService'));
    }

    return this.http.get<{
      valido: boolean;
      diaInicio: string;
      diaFin: string;
    }>(environment.API_URL + 'cliente/Operador/pedidoextra/fecha/validar', {
      params: {
        idOperador: String(idOperador),
      },
    });
  }


  getGestorPorOperador() {
    const idOperador = this.userService.getUserInfo()?.idOperador;

    if (!idOperador) {
      return throwError(() => new Error('No se ha encontrado idOperador en userService'));
    }

    return this.http.get<IGestor>(environment.API_URL + 'cliente/Operador/gestor', {
      params: {
        idOperador: String(idOperador),
      },
    });
  }
}
